import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-faecc568"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "actuator-monitor",
  "element-loading-text": "模型加载中...",
  "element-loading-background": "rgba(0, 0, 0, 0.6)"
};
const _hoisted_2 = {
  class: "controls"
};
const _hoisted_3 = {
  key: 0,
  class: "actuator-rotation-controls"
};
const _hoisted_4 = {
  ref: "threeContainer",
  class: "three-container"
};
const _hoisted_5 = {
  class: "actuator-info-window"
};
const _hoisted_6 = {
  class: "info-header"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "执行器状态监控", -1));
const _hoisted_8 = {
  class: "metrics-grid"
};
const _hoisted_9 = {
  class: "metric-item full-width"
};
const _hoisted_10 = {
  class: "metric-label"
};
const _hoisted_11 = {
  class: "metric-label"
};
const _hoisted_12 = {
  class: "metric-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-label"
}, "气瓶压力", -1));
const _hoisted_14 = {
  class: "metric-value"
};
const _hoisted_15 = {
  class: "metric-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-label"
}, "电池电压", -1));
const _hoisted_17 = {
  class: "metric-value"
};
const _hoisted_18 = {
  class: "metric-item"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-label"
}, "信号强度", -1));
const _hoisted_20 = {
  class: "metric-value"
};
const _hoisted_21 = {
  class: "metric-item"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-label"
}, "腔内温度", -1));
const _hoisted_23 = {
  class: "metric-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _directive_loading = _resolveDirective("loading");
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    type: $data.wellCoverOpen ? 'danger' : 'info',
    onClick: $options.toggleWellCover,
    disabled: !$data.wellCover,
    class: _normalizeClass($data.wellCoverOpen ? 'danger' : 'info')
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.wellCoverOpen ? '关闭井盖' : '打开井盖'), 1)]),
    _: 1
  }, 8, ["type", "onClick", "disabled", "class"]), _createVNode(_component_el_button, {
    type: $data.wellBarrelHidden ? 'primary' : 'secondary',
    onClick: $options.toggleWellBarrel,
    disabled: !_ctx.wellBarrel && !_ctx.wellBackWall,
    class: _normalizeClass($data.wellBarrelHidden ? 'primary' : 'secondary')
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.wellBarrelHidden ? '显示井桶' : '隐藏井桶'), 1)]),
    _: 1
  }, 8, ["type", "onClick", "disabled", "class"]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.viewActuator,
    disabled: $data.isViewingActuator
  }, {
    default: _withCtx(() => [_createTextVNode(" 查看执行器 ")]),
    _: 1
  }, 8, ["onClick", "disabled"]), $data.isViewingActuator ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
    type: $data.actuatorRotating ? 'danger' : 'success',
    onClick: $options.toggleActuatorRotation,
    disabled: !_ctx.actuator,
    class: "rotation-button"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.actuatorRotating ? '停止旋转' : '开始旋转'), 1)]),
    _: 1
  }, 8, ["type", "onClick", "disabled"])])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
    type: "success",
    onClick: $options.initScene
  }, {
    default: _withCtx(() => [_createTextVNode(" 初始化场景 ")]),
    _: 1
  }, 8, ["onClick"])]), _createElementVNode("div", _hoisted_4, null, 512), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", {
    class: _normalizeClass(["status-indicator", $options.getStatusClass()])
  }, null, 2)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, "设备编号： " + _toDisplayString($data.actuatorMetrics.temperature), 1), _createElementVNode("div", _hoisted_11, "安装位置：" + _toDisplayString($data.actuatorMetrics.location), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($data.actuatorMetrics.pressure) + " MPa", 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString($data.actuatorMetrics.vibration) + " %", 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString($data.actuatorMetrics.current) + " %", 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString($data.actuatorMetrics.current1) + "℃", 1)])])])])), [[_directive_loading, $data.isLoading]]);
}